module.exports = __webpack_public_path__ + "img/snare2.1a13ed0b.jpg";